import React from 'react';
import Rete from 'rete';

export class LabelAddButtonControl extends Rete.Control {

    static component = ({labelText, onAddClick, isAddButtonActive, isComponentAdded}) => {

        const AddButton = () => (
            <button
                className="add-nested-node-btn"
                onClick={() => onAddClick()}>
                +
            </button>
        );

        return (
            <div>
                {(isAddButtonActive || isComponentAdded) && <label>{labelText}</label>}
                {isAddButtonActive && <AddButton />}
            </div>
        )
    };

    constructor(emitter, key, node, readonly = false, labelText, onAddClick, isAddButtonActive) {
        super(key);
        this.emitter = emitter;
        this.key = key;
        this.component = LabelAddButtonControl.component;
        this.state = {
            answers: [],
        }

        this.props = {
            readonly,
            labelText: labelText,
            onAddClick: onAddClick,
            isAddButtonActive: isAddButtonActive,
            isComponentAdded: false
        };

        //this.emitter.trigger("process");
    }

    setAddButtonActive(value) {
        this.props.isAddButtonActive = value;

        if (typeof this.update === 'function') {
            this.update();
        }
    }

    setComponentIsAdded(value) {
        this.props.isComponentAdded = value;
    }
}